module.exports = __webpack_public_path__ + "38aefcac117e5d35c2be0e4c379f66e4.png";